import { images } from "assets/images";
import { useTranslation } from "react-i18next";
import * as React from "react";
import { Image } from "react-bootstrap";

type ReportInfoBoxProps = {
  completedReport: object;
};

const ReportInfoBox = ({ completedReport }: ReportInfoBoxProps) => {
  const { t } = useTranslation();
  const iconName = Object.keys(completedReport)[0];
  const numReports = Object.values(completedReport)[0];

  return (
    <div className="reportInfoContainer">
      <div className="reportInfoWhiteContainer">
        <div className="borderDash">
          <div className="svgBox">
            <Image src={images[iconName]} alt={iconName} />
          </div>
          <div className="reportNum">{numReports}</div>
          <div className="reportType">{t(iconName)}</div>
        </div>
      </div>
    </div>
  );
};

export default ReportInfoBox;
